import { ApplicationInsights, SeverityLevel } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { AdditionalInfo, Logger, TelemetryException } from './Logger';

function hasValidInstrumentationKey(instrumentationKey): boolean {
    return Boolean(instrumentationKey);
}

let _appInsight = null;

function initAppInsight(instrumentationKey, history) {
    if (window.aiInitialized) {
        return _appInsight;
    }

    window.aiInitialized = true;

    const reactPlugin = new ReactPlugin();

    _appInsight = new ApplicationInsights({
        config: {
            instrumentationKey,
            maxBatchInterval: 0,
            disableFetchTracking: false,
            // @ts-ignore
            extensions: [reactPlugin],
            extensionConfig: {
                [reactPlugin.identifier]: {
                    history
                }
            }
        }
    });

    _appInsight.loadAppInsights();

    return _appInsight;
}

function log(message: string, additionalInfo?: AdditionalInfo) {
    let { apiUrl } = window.appConfig;
    
    fetch(`${apiUrl}/log`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            message,
            additionalInfo
        })
    });
}

function logError(error: unknown, additionalInfo?: AdditionalInfo) {
    let { apiUrl } = window.appConfig;
    
    fetch(`${apiUrl}/log`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            error,
            additionalInfo
        })
    });
}

export function createApplicationInsightsLogger(history: History): Logger {
    const { aiTelemetry, site } = window.appConfig;

    if (!hasValidInstrumentationKey(aiTelemetry)) {
        throw new Error(
            'Could not initialize telemetry, make sure env variable AI_TELEMETRY_INSTRUMENTATION_KEY is set.'
        );
    }

    const appInsight = initAppInsight(aiTelemetry, history);

    return {
        logInfo: (message: string, additionalInfo?: AdditionalInfo) => {
            log(message, additionalInfo);
        },
        logException: (error: Error, additionalInfo?: AdditionalInfo) => {
            const telemetryException: TelemetryException = {
                exception: error,
                properties: {
                    client: site,
                    ...additionalInfo
                },
                severityLevel: SeverityLevel.Error
            };
            
            logError(error, additionalInfo);
            
            appInsight.trackException(telemetryException);
            
        }
    };
}
